import React from "react";

import Layout from "@components/Layout/Layout";
import TestDriveUnavailable from "@components/TestDriveUnavailable/TestDriveUnavailable";

import { useConfigurationSelector } from "@redux/reducers/appConfig";

function getIsTestDriveAvailable(configuration) {
  return (
    configuration?.testDrive?.enabled &&
    configuration?.app?.discoveryJourney?.enabled
  );
}

export function withTestDriveGate(Component) {
  const WithTestDriveGateComponent = props => {
    const configuration = useConfigurationSelector();

    if (!getIsTestDriveAvailable(configuration)) {
      return (
        <Layout isGetPageNameByPathname>
          <TestDriveUnavailable />
        </Layout>
      );
    }

    return <Component {...props} />;
  };

  WithTestDriveGateComponent.getInitialProps = async (ctx, ...args) => {
    const { appConfig } = ctx.store.getState();

    if (!getIsTestDriveAvailable(appConfig.configuration)) {
      return { namespacesRequired: ["common"] };
    }

    return Component.getInitialProps?.(ctx, ...args);
  };

  return WithTestDriveGateComponent;
}
